/*

// Wait for 3 seconds after the document has fully loaded
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Find and remove the "undefined" text
    removeUndefinedText();

    // Wait for an additional 5 seconds and then check again
    setTimeout(function() {
      removeUndefinedText();
    }, 5000); // Wait for 5 seconds (5000 milliseconds)
  }, 3000); // Wait for 3 seconds (3000 milliseconds)
});

function removeUndefinedText() {
  // Find all elements containing the text "undefined"
  var elementsWithUndefined = document.querySelectorAll(':contains("undefined")');

  // Loop through the selected elements and remove the text
  elementsWithUndefined.forEach(function(element) {
    element.innerHTML = element.innerHTML.replace(/undefined/g, '');
  });
}

window.onload = function () {
      // Wait for the document to fully load before running the code
    document.addEventListener('DOMContentLoaded', function() {
      // Select all elements containing the text "undefined"
      var elementsWithUndefined = document.querySelectorAll(':contains("undefined")');
    
      // Loop through the selected elements and remove the text
      elementsWithUndefined.forEach(function(element) {
        element.textContent = element.textContent.replace(/undefined/g, '');
      });
    });
    if(document.querySelector('#slider-component .slider')){
        
        var elems = document.querySelectorAll('#slider-component .slider');
        elems.forEach(elem=>{
        var mediaQuery = window.matchMedia('(max-width: 767px)');
          if(mediaQuery.matches){
            var flkty = new Flickity( elem, {
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            groupCells:true
            });
          }else{
            if(elem.querySelectorAll('.slider-item').length > 3){
                var flkty = new Flickity( elem, {
                // options
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: true,
                  groupCells:true
                });
            }
          }
      })

    }
    if(document.querySelector('.dropdown-container')){
        document.querySelectorAll('.dropdown-container').forEach(item=>{
          item.addEventListener('click',function(e){
            item.classList.toggle('open');
          });
        })
    }
    if(document.querySelector('.menu-drawer__inner-container')){
        document.getElementById('ham').addEventListener('click',function(){
            document.querySelector('body').classList.toggle('open_drawer');
        })
    };

    // Create flickity to product images
    if(document.querySelector('.product-section .slider-container .slider')){
        var elem = document.querySelector('.product-section .slider-container .slider');
        var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false
        });
    } 
    if(document.querySelector('.product-section .slider-container .customize-tools')){
        var elem = document.querySelector('.product-section .slider-container .customize-tools > .flex');
        var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        asNavFor:".product-section .slider-container .slider",
        pageDots: false,
        prevNextButtons: false
        });

    }
    if(document.querySelector('.expert-slider')){
        var elem = document.querySelector('.expert-slider');
        var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        autoPlay:2000
        });
    }
    var mediaQuery = window.matchMedia('(max-width: 767px)');
    if(mediaQuery.matches){
        if(document.querySelector('.logo-list_container')){
            var elem = document.querySelector('.logo-list_container');
            var flkty = new Flickity( elem, {
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false,
            autoPlay:2000
            });
        }
      


    }
}

*/

window.__nativeFetch = window.fetch.bind(window);

document.addEventListener('click', async (e) => {
  const addBtn = e.target.closest('[data-add-to-cart]');
  if (!addBtn) return;

  e.preventDefault();

  const form = addBtn.closest('form');
  if (!form) return;

  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId || variantId === 'undefined') {
    console.error('[ATC] Blocked — variant ID is:', variantId);
    return;
  }

  const cartDrawer = document.querySelector('cart-drawer');
  const drawerInner = cartDrawer?.querySelector('.drawer__inner');
  const originalHTML = addBtn.innerHTML;

  // ── STEP 1: Button loading state ─────────────────────────────
  addBtn.innerHTML = `
    <span style="display:inline-flex;align-items:center;gap:8px;justify-content:center;">
      <span class="atc-spinner" style="
        width:16px;height:16px;border-radius:50%;
        border:2px solid rgba(255,255,255,0.35);
        border-top-color:#fff;
        animation:atc-spin 0.7s linear infinite;
        flex-shrink:0;
        display:inline-block;
      "></span>
      Adding...
    </span>`;
  addBtn.disabled = true;
  addBtn.classList.add('is-loading');

  // Inject spinner keyframes once
  if (!document.getElementById('atc-spin-style')) {
    const style = document.createElement('style');
    style.id = 'atc-spin-style';
    style.textContent = `@keyframes atc-spin { to { transform: rotate(360deg); } }`;
    document.head.appendChild(style);
  }

  // ── STEP 2: Open drawer with skeleton ────────────────────────
  if (cartDrawer) {
    cartDrawer.open?.();
    if (drawerInner) {
      drawerInner.innerHTML = `
        <style>
          @keyframes skel-shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position:  600px 0; }
          }
          .skel {
            background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
            background-size: 600px 100%;
            animation: skel-shimmer 1.4s ease-in-out infinite;
            border-radius: 6px;
          }
        </style>
        <div style="padding:24px 20px;">

          <!-- Header skeleton -->
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:28px;">
            <div class="skel" style="width:80px;height:18px;"></div>
            <div class="skel" style="width:24px;height:24px;border-radius:50%;"></div>
          </div>

          <!-- Cart item skeleton row -->
          <div style="display:flex;gap:14px;margin-bottom:24px;">
            <div class="skel" style="width:80px;height:80px;border-radius:8px;flex-shrink:0;"></div>
            <div style="flex:1;display:flex;flex-direction:column;gap:10px;padding-top:4px;">
              <div class="skel" style="width:75%;height:14px;"></div>
              <div class="skel" style="width:45%;height:12px;"></div>
              <div class="skel" style="width:35%;height:12px;"></div>
              <div style="display:flex;justify-content:space-between;align-items:center;margin-top:4px;">
                <div class="skel" style="width:72px;height:28px;border-radius:4px;"></div>
                <div class="skel" style="width:52px;height:14px;"></div>
              </div>
            </div>
          </div>

          <!-- Divider -->
          <div style="height:1px;background:#e8e8e8;margin-bottom:20px;"></div>

          <!-- Subtotal skeleton -->
          <div style="display:flex;justify-content:space-between;margin-bottom:8px;">
            <div class="skel" style="width:60px;height:14px;"></div>
            <div class="skel" style="width:70px;height:14px;"></div>
          </div>
          <div style="display:flex;justify-content:space-between;margin-bottom:24px;">
            <div class="skel" style="width:90px;height:12px;"></div>
            <div class="skel" style="width:50px;height:12px;"></div>
          </div>

          <!-- CTA button skeleton -->
          <div class="skel" style="width:100%;height:48px;border-radius:6px;"></div>
        </div>`;
    }
  }

  // ── STEP 3: POST to /cart/add ─────────────────────────────────
  try {
    const formData = new FormData(form);
    const addResponse = await window.__nativeFetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });

    if (!addResponse.ok) {
      const errData = await addResponse.json().catch(() => ({}));
      throw new Error(errData.description || `HTTP ${addResponse.status}`);
    }

  } catch (err) {
    console.error('[ATC] /cart/add failed:', err.message);
    if (drawerInner) {
      drawerInner.innerHTML = `
        <div style="padding:32px 24px;text-align:center;">
          <p style="color:#c0392b;font-size:14px;margin:0 0 8px;">Could not add to cart</p>
          <p style="font-size:12px;opacity:0.6;margin:0;">${err.message}</p>
        </div>`;
    }
    addBtn.innerHTML = originalHTML;
    addBtn.disabled = false;
    addBtn.classList.remove('is-loading');
    return;
  }

  // ── STEP 4: Fetch sections in parallel ───────────────────────
  try {
    const [cartDrawerData, bubbleData] = await Promise.all([
      window.__nativeFetch('/?sections=cart-drawer', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(r => r.json()),
      window.__nativeFetch('/?sections=cart-icon-bubble', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(r => r.json()),
    ]);

    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents({
        id: Date.now(),
        sections: { ...cartDrawerData, ...bubbleData },
      });
    } else if (drawerInner && cartDrawerData['cart-drawer']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartDrawerData['cart-drawer'], 'text/html');
      const newInner = doc.querySelector('.drawer__inner');
      if (newInner) drawerInner.innerHTML = newInner.innerHTML;
    }

    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && bubbleData['cart-icon-bubble']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(bubbleData['cart-icon-bubble'], 'text/html');
      const newBubble = doc.getElementById('cart-icon-bubble');
      if (newBubble) bubble.innerHTML = newBubble.innerHTML;
    }

  } catch (err) {
    console.error('[ATC] Section render failed:', err.message);
    cartDrawer?.renderContents?.({ id: Date.now(), sections: {} });
  }

  // ── STEP 5: Restore button ────────────────────────────────────
  addBtn.innerHTML = originalHTML;
  addBtn.disabled = false;
  addBtn.classList.remove('is-loading');
});

// End of code for function of main-product-new.liquid and cart-drawer snippet.

// Script code to open filters. This is just temporary
(function () {
  function openAllFilters() {
    const filters = document.querySelectorAll(
      '.js-filter details, details.js-filter'
    );

    filters.forEach((filter) => {
      if (!filter.hasAttribute('open')) {
        filter.setAttribute('open', '');
      }

      const summary = filter.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    });
  }

  openAllFilters();

  document.addEventListener('shopify:section:load', openAllFilters);
  document.addEventListener('facet:render', openAllFilters);

  const observer = new MutationObserver(openAllFilters);
  observer.observe(document.body, { childList: true, subtree: true });
})();
// END - Script code to open filters.

// Script to fix the issue of ATC labels and variant issues to the add to cart buttons when the preorder or global js injects something
(function() {
  document.addEventListener('DOMContentLoaded', function() {

    function patchVariantSelects() {
      var el = document.querySelector('variant-selects');
      if (!el) return;

      var proto = Object.getPrototypeOf(el);
      if (!proto || !proto.updateMedia) {
        setTimeout(patchVariantSelects, 100);
        return;
      }

      var originalUpdateMedia = proto.updateMedia;
      proto.updateMedia = function(variant) {
        try {
          originalUpdateMedia.call(this, variant);
        } catch(e) {
          console.warn('[Patch] updateMedia crashed:', e);
          fixButtonForVariant(variant);
        }
      };

      var originalRenderProductInfo = proto.renderProductInfo;
      if (originalRenderProductInfo) {
        proto.renderProductInfo = function(requestUrl) {
          var result;
          try {
            result = originalRenderProductInfo.call(this, requestUrl);
          } catch(e) {
            console.warn('[Patch] renderProductInfo threw synchronously:', e);
            fixButtonFromCurrentSelections();
            return;
          }

          if (result && typeof result.then === 'function') {
            return result.catch(function(e) {
              console.warn('[Patch] renderProductInfo promise rejected:', e);
              fixButtonFromCurrentSelections();
            });
          }

          return result;
        };
      }

      console.log('[Patch] VariantSelects patched successfully');
    }

    function getSelectedVariantTitle() {
      var values = [];
      document.querySelectorAll('fieldset.product-form__input').forEach(function(fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) values.push(checked.value);
      });
      return values.join(' / ');
    }

    function fixButtonFromCurrentSelections() {
      var variantDataEl = document.querySelector('variant-selects script[type="application/json"]');
      if (!variantDataEl) return;

      var variants;
      try {
        variants = JSON.parse(variantDataEl.textContent);
      } catch(e) {
        return; // malformed JSON, do nothing
      }

      // Match by options array, not title string
      var selectedOptions = [];
      document.querySelectorAll('fieldset.product-form__input').forEach(function(fieldset) {
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (checked) selectedOptions.push(checked.value.trim());
      });

      var variant = variants.find(function(v) {
        return v.options && v.options.every(function(opt, i) {
          return opt.trim() === selectedOptions[i];
        });
      });

      console.log('[Patch] Fixing button for variant:', selectedOptions.join(' / '), 
        variant ? (variant.available ? 'AVAILABLE' : 'SOLD OUT') : 'NOT FOUND');

      // KEY GUARD: if no variant matched, do NOT touch the button at all
      if (!variant) {
        console.warn('[Patch] No variant matched — skipping button update to preserve existing ID');
        return;
      }

      fixButtonForVariant(variant);
    }

    function fixButtonForVariant(variant) {
      if (!variant) return;
      // CRITICAL: never write undefined/null as the variant ID
      if (!variant.id) return;

      document.querySelectorAll('input[name="id"]').forEach(function(input) {
        input.value = variant.id;
      });

      var btn = document.querySelector('[data-add-to-cart]');
      var textSpan = document.querySelector('[data-add-to-cart-text]');
      if (!btn || !textSpan) return;

      if (variant.available) {
        textSpan.textContent = 'Add to cart';
        btn.disabled = false;G
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.setAttribute('aria-label', 'Add to cart');
      } else {
        textSpan.textContent = 'Sold out';
        btn.disabled = true;
        btn.setAttribute('disabled', 'true');
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-label', 'Sold out');
      }

      console.log('[Patch] Button updated — ID:', variant.id, '| Status:', variant.available ? 'Add to cart' : 'Sold out');
    }

    patchVariantSelects();

    document.querySelectorAll('input[type="radio"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        setTimeout(fixButtonFromCurrentSelections, 350);
      });
    });

  });
})();